module.exports = __webpack_public_path__ + "img/food_intro2_opt.72c04b41.jpg";